// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconMathSymbols } from '@tabler/icons';

// constant
const icons = {
    IconMathSymbols
};

// ==============================|| ADMINISTRATION - MENU ITEMS ||============================== //

const administration = {
    id: 'administration-route',
    title: <FormattedMessage id="SYS00002" />,
    type: 'group',
    children: [
        {
            id: 'administration-accounting',
            title: <FormattedMessage id="ACC00001" />,
            type: 'item',
            url: '/amministrazione/contabilita',
            icon: icons.IconMathSymbols
        }
    ]
};

export default administration;